import { TenderingBandwidthModel } from "../models/TenderingBandwidthModel";
import API, { client } from "./API";

const TenderingBandwidthService = {
  async getAllTenderingBandwidths() {
    const response = await API().get("ProjectTenderingBandwidth", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularTenderingBandwidth(tb_id: number) {
    const response = await API().get("TenderingBandwidth");
    return response.data.filter(
      (cur_tb: TenderingBandwidthModel) => cur_tb.tenderingBandwidthId === tb_id
    )[0];
  },
  async createTenderBandwidth(data: TenderingBandwidthModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id
          ? `ProjectTenderingBandwidth/${id}`
          : "ProjectTenderingBandwidth",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default TenderingBandwidthService;
